

export const CartInformation = (props:any) => {
    const {promocode,original_price,final_price,subscription,pro} = props;
  return (
    <div className="col-sm-6 px-4">
    <table className="table table-striped border-0 mt-4">
      <tbody>
        <tr>
          <th scope="row">Promo Code:</th>
          <td>{promocode}</td>
        </tr>
        <tr>
          <th scope="row">Original Price:</th>
          <td>{original_price}</td>
        </tr>
        <tr>
          <th scope="row">Final Price:</th>
          <td>{final_price}</td>
        </tr>
        <tr>
          <th scope="row">Subscription:</th>
          <td>{subscription?"true":"false"}</td>
        </tr>
        <tr>
          <th scope="row">Pro:</th>
          <td>{pro?"true":"false"}</td>
        </tr>
        </tbody>
      </table>
    </div>
  )
}
